var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniChartUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 13,
    viewBox: "0 0 30 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.5L4.6129 8.88095L6.41935 9.59524L9.12903 7.45238L14.5484 6.02381L15.4516 7.45238L18.4624 3.64286L19.9677 4.83333L29 1.5",
    stroke: "#33CC66",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniChartUp);
export default __webpack_public_path__ + "static/media/miniChartUp.3ec5b0227fec9f3b501e5dcc0dc3c5c0.svg";
export { ForwardRef as ReactComponent };